module.exports = __webpack_public_path__ + "fonts/25134ff2effb40eb85839b3684e22199.f9a84df4.ttf";